import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 14.75v3.5m3.724-12.679.43-1.891c.15-.661.226-.991.131-1.25a1.02 1.02 0 0 0-.474-.541c-.254-.139-.62-.139-1.349-.139H7.538c-.73 0-1.095 0-1.349.139a1.02 1.02 0 0 0-.474.54c-.095.26-.02.59.13 1.25l.431 1.892c.079.345.118.518.124.691.006.154-.007.308-.04.46-.036.17-.105.334-.243.663l-1.96 4.687c-.306.731-.46 1.096-.39 1.39.059.255.225.48.461.623.27.165.694.165 1.54.165h8.463c.847 0 1.27 0 1.54-.165.237-.144.403-.368.463-.624.068-.293-.085-.658-.39-1.389l-1.961-4.687c-.138-.329-.207-.493-.243-.664a1.859 1.859 0 0 1-.04-.459c.006-.173.045-.346.124-.691Z"
	})]
});
const ForwardRef = forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
